import { faBuilding, faUser } from "@fortawesome/free-regular-svg-icons";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { useSnapshot } from "valtio";
import { tabsState } from "../../state/tabs";
import { MenuSection } from "../menu-section";
import { cn } from "../utils/cn";
import { ClientButtonLink } from "./ClientButtonLink";
import { IconButtonLink } from "./IconButtonLink";
import { ImageButtonLink } from "./ImageButtonLink";
import { MemberButtonLink } from "./MemberButtonLink";
import { getBaseUrl, scrollToTop } from "./utils";
import { Link, useMatch } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useStatsigClient } from "../../hooks";
import {
  faHome,
  faHouse,
  faHouseChimney,
} from "@fortawesome/free-solid-svg-icons";
import { HomeImageButton } from "../buttons/image-button/HomeImageButton";
import { HomeImageButtonLink } from "./HomeImageButtonLink";
import homeIcon from "../../assets/home_icon.svg";
interface Props {
  organizationId: string;
  className?: string;
  organizationLogo?: string;
}

const NavigationDesktopBar = ({
  organizationId,
  className,
  organizationLogo,
}: Props) => {
  const tabsSnap = useSnapshot(tabsState);
  const baseUrl = getBaseUrl(organizationId);
  const match = useMatch(baseUrl);
  const statsigClient = useStatsigClient();

  const isHomeActive = Boolean(match);

  return (
    <div
      className={cn(
        "flex flex-row gap-10 items-center flex-grow flex-shrink min-w-0",
        className,
      )}
    >
      {statsigClient?.checkGate("new_home_button") ? (
        <HomeImageButtonLink
          href={baseUrl}
          imageUrl={homeIcon}
          alt="VOCS Studio"
          onClick={scrollToTop}
          indicatorProps={{
            imageUrl: organizationLogo ?? "",
            variant: "image",
            alt: "VOC Studio",
          }}
        />
      ) : (
        <ImageButtonLink
          href={baseUrl}
          imageUrl={organizationLogo}
          alt="VOCS Studio"
          onClick={scrollToTop}
        />
      )}

      <div className="flex flex-row gap-8 items-center flex-grow flex-shrink overflow-x-scroll">
        <MenuSection>
          <IconButtonLink href={`${baseUrl}/members`} icon={faUser} />
          {tabsSnap.members.length ? <MenuSection.Separator /> : null}
          {tabsSnap.members.map((memberId) => (
            <MemberButtonLink
              key={memberId}
              organizationId={organizationId}
              memberId={memberId}
            />
          ))}
        </MenuSection>
        <MenuSection>
          <IconButtonLink href={`${baseUrl}/clients`} icon={faBuilding} />
          {tabsSnap.clients.length ? <MenuSection.Separator /> : null}
          {tabsSnap.clients.map((clientId) => (
            <ClientButtonLink
              key={clientId}
              organizationId={organizationId}
              clientId={clientId}
            />
          ))}
        </MenuSection>
      </div>
    </div>
  );
};

NavigationDesktopBar.displayName = "NavigationDesktopBar";

export { NavigationDesktopBar };
